export enum RangesActionTypes {
  UPDATE_RANGE = 'UPDATE_RANGE',
}